import { createFileRoute } from '@tanstack/react-router';
import { CrmHelpdeskAiContentPage } from '@pages/crm';

export const Route = createFileRoute('/$locale/_authenticated/crm/helpdesk/instructions/new')({
  component: ContentCreateRoute,
});
function ContentCreateRoute() {
  const { locale } = Route.useParams();
  return (
    <CrmHelpdeskAiContentPage
      locale={locale}
      kind="instructions"
      create
      search={Route.useSearch()}
    />
  );
}
